import Config from 'services/config/config';
import callWebService, {callTypes} from 'services/utils/networks/network';
import {
    ADD_CASE,
    BANK_LIST,
    CAR_BRAND,
    CAR_MODEL,
    CAR_VARIANT,
    CASE_BY_ID,
    CASE_LIST,
    CASES_BY_LSQ_DEALER_ID,
    CASES_STATUS_UPDATE,
    LOAN_ACCOUNTS,
    LOAN_APPLICATION_BY_ID,
    LOAN_APPLICATION_UPDATE,
    LOAN_UNDERTAKING,
    PAYMENT_RAISE,
    UCD_LIST,
    UCD_VIEW,
    LOAN_PAYMENT_REQUEST,
    LOAN_TRANCHES,
    UPDATE_TRANCHE_STATUS,
    PAYMENT_RAISE_UPDATE,
    ACCOUNT_PENNY_DROP,
    APPROVAL_REQUEST,
    BANK_SHEET_UPLOAD,
    GET_PAYOUT_DETAILS,
    UPDATE_PAYOUT_DETAILS,
    GET_ACCOUNT_DETAILS,
    NEW_BANK_DETAILS,
    PAYOUT_CONFIGURATION_LIST,
    PAYOUT_CONFIGURATION_VERIFY,
    B2C_LEAD,
    FORE_CLOSURE_ACCOUNT,
    VEHICLE_DETAILS,
    UPDATE_LOAN_APPLICATION_FOR_B2C,
    B2C_CASE_LOGIN_WITHOUT_DEALER,
    RC_CASE_LISTING,
    RC_CASE_BY_ID, RTO_DETAILS_UPDATE,
    COMMISSION_PAYOUT_CASE_LIST,
    VALIDATE_INVOICE_STATUS,
    PREVIEW_INVOICE,
    RAISE_INVOICE,
    CAR_BRAND_FOR_B2C,
    CAR_MODEL_FOR_B2C
} from "./type";

export const ucdListRequest = (page = 1, businessName) => async (dispatch) => {
    let url = `${Config.CarLoan.ucdList}?page=${page}&fusion_list=1`;
    if(businessName) {
        url+= `&search_key=${businessName}`
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    const {data} = res;
    dispatch({
        type: UCD_LIST,
        payload: data?.response?.data,
    });
}

export const ucdViewRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.ucdView}?id=${id}`
    );
    const {data} = res;
    dispatch({
        type: UCD_VIEW,
        payload: data?.response,
    });
}

export const addCaseRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.newCase}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: ADD_CASE,
            payload: data,
        });
    } else {
        return res;
    }
}

export const caseListRequest = (dealerId, page = 1, flow = '', source = '', filter='') => async (dispatch) => {
    let keys = Object.keys(filter);
    let url = `${Config.CarLoan.caseListing}?page=${page}&dealer_id=${dealerId}&flow=${flow}&loan_source=${source}`;
    if(keys){
        keys.map(val => {
            if(filter[val]){
                url+= `&${val}=${filter[val]}`
            }
        })
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    const {data} = res;
    dispatch({
        type: CASE_LIST,
        payload: data?.response?.data,
    });
}

export const caseByIdRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.caseById}?id=${id}`
    );
    const {data} = res;
    dispatch({
        type: CASE_BY_ID,
        payload: data?.response,
    });
}

export const carBrandRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.carBrand}`
    );
    const {data} = res;
    dispatch({
        type: CAR_BRAND,
        payload: data?.response?.data,
    });
}

export const carModelRequest = (brandName=null, brandId=null) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.carModel}?brand_name=${brandName}&brand_id=${brandId}`
    );
    const {data} = res;
    dispatch({
        type: CAR_MODEL,
        payload: data?.response?.data,
    });
}

export const carVariantRequest = (modelName) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.carVariant}?model_slug=${modelName}`
    );
    const {data} = res;
    dispatch({
        type: CAR_VARIANT,
        payload: data?.response?.data,
    });
}

export const bankListRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.bankList}`
    );
    const {data} = res;
    dispatch({
        type: BANK_LIST,
        payload: data?.response?.data,
    });
}

export const caseByLsqDealerIdRequest = (dealerId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.caseByLsqDealerId}?dealer_id=${dealerId}`
    );
    const {data} = res;
    dispatch({
        type: CASES_BY_LSQ_DEALER_ID,
        payload: data?.response?.data,
    });
}

export const caseStatusUpdateRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.updateCaseStatus}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: CASES_STATUS_UPDATE,
            payload: data,
        });
    } else {
        return res;
    }
}

export const loanApplicationByIdRequest = (id, flow = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.loanApplicationById}?case_id=${id}&flow=${flow}`

    );
    const {data} = res;
    dispatch({
        type: LOAN_APPLICATION_BY_ID,
        payload: data?.response,
    });
}

export const loanApplicationUpdateRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.loanApplicationUpdate}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_APPLICATION_UPDATE,
        payload: data?.response,
    });
}

export const loanPaymentRaiseRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.raisePayment}`
    );
    const {data} = res;
    dispatch({
        type: PAYMENT_RAISE,
        payload: data?.response,
    });
}

export const loanAccountRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.loanAccount}?id=${id}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_ACCOUNTS,
        payload: data?.response?.data,
    });
}

export const loanUndertakingRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.loanUndertaking}`
    );
    const {data} = res;
    dispatch({
        type: LOAN_UNDERTAKING,
        payload: data?.response,
    });
}

export const loanTranchesRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.loanTranches}?id=${id}`
    );
    const { data } = res;
    dispatch({
        type: LOAN_TRANCHES,
        payload: data?.response?.data,
    });
};

export const loanPaymentRequestRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.loanPaymentRequest}?id=${id}`
    );
    const { data } = res;
    dispatch({
        type: LOAN_PAYMENT_REQUEST,
        payload: data?.response?.data,
    });
};

export const updateTrancheStatusRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.updateTrancheStatus}`
    );
    const {data} = res;
    dispatch({
        type: UPDATE_TRANCHE_STATUS,
        payload: data?.response,
    });
}

export const loanPaymentRaiseUpdateRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.raisePaymentUpdate}`
    );
    const {data} = res;
    dispatch({
        type: PAYMENT_RAISE_UPDATE,
        payload: data?.response,
    });
}

export const accountPennyDropRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.accountPennyDrop}`
    );
    const {data} = res;
    dispatch({
        type: ACCOUNT_PENNY_DROP,
        payload: data?.response,
    });
    return data?.response
}

export const loanApprovalRequestRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.approvalRequest}`
    );
    const {data} = res;
    dispatch({
        type: APPROVAL_REQUEST,
        payload: data?.response,
    });
}


export const bankSheetDetailsUpload = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.bankSheetUpload}`
    );
    const {data} = res;
    dispatch({
        type: BANK_SHEET_UPLOAD,
        payload: data?.response,
    });
    return data?.response
}

export const payoutDetailsWithId = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.getThePayoutDetails}?id=${id}`
    );
    const { data } = res;
    dispatch({
        type: GET_PAYOUT_DETAILS,
        payload: data?.data,
    });
};

export const updateAllPayoutDetails = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.updateThePayoutDetails}`
    );
    const {data} = res;
    dispatch({
        type: UPDATE_PAYOUT_DETAILS,
        payload: data?.response,
    });
    return data?.response
}

export const payoutAccountDetails = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.getAccountDetailsForPayout}?id=${id}`
    );
    const { data } = res;
    dispatch({
        type: GET_ACCOUNT_DETAILS,
        payload: data?.data,
    });
};

export const newBankDetailsRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.newBankDetails}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: NEW_BANK_DETAILS,
            payload: data?.response.data,
        });
    }
};

export const payoutConfigurationListRequest = (page = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.payoutConfigurationList}?page=${page}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: PAYOUT_CONFIGURATION_LIST,
            payload: data?.response.data,
        });
    }
};

export const payoutConfigurationVerifyRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.payoutConfigurationVerify}`
    );

    if (res) {
        const { data } = res;
        dispatch({
            type: PAYOUT_CONFIGURATION_VERIFY,
            payload: data?.response,
        });
    }
    return data?.response;
};

export const foreClosureAddAccountRequest = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        `${Config.CarLoan.foreClosureAccountDetails}`
    );
    const {data} = res;
    dispatch({
        type: FORE_CLOSURE_ACCOUNT,
        payload: data?.response,
    });
    return data?.response
}





export const b2cLeadListRequest = (flow, page = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.b2cLeadList}?flow=${flow}&page=${page}`
    );
    const { data } = res;
    dispatch({
        type: B2C_LEAD,
        payload: data?.response?.data,
    });
};

export const vehicleDetailsRequest = (vehicleNo) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.vehicleDetails}?vehicle_no=${vehicleNo}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: VEHICLE_DETAILS,
            payload: data?.response,
        });
    }
};

export const updateLoanApplicationForB2C = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.b2cUpdateLoanApplication}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: UPDATE_LOAN_APPLICATION_FOR_B2C,
            payload: data,
        });
    } else {
        return res;
    }
}

export const addB2cCaseLoginWithDealer = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.b2cCaseLoginWithoutDealer}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: B2C_CASE_LOGIN_WITHOUT_DEALER,
            payload: data,
        });
    } else {
        return res;
    }
}

export const rcCaseListingRequest = (page=1, caseType = 'B2C_LOAN', filter = '') => async (dispatch) => {
    let keys = Object.keys(filter);
    let url = `${Config.CarLoan.rcCaseList}?page=${page}&type=${caseType}`;
    if(keys){
        keys.map(val => {
            if(filter[val]){
                url+= `&${val}=${filter[val]}`
            }
        })
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: RC_CASE_LISTING,
            payload: data?.response?.data,
        });
    }
};

export const rcCaseByIdRequest = (applicationId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.rcCaseById}?application_id=${applicationId}`
    );

    if (res && res.data) {
        const { data } = res;
        dispatch({
            type: RC_CASE_BY_ID,
            payload: data?.response?.data,
        });
    }
};

export const rtoDetailsUpdateRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.rtoDetailsUpdate}`
    );
    if (res?.data) {
        const {data} = res;
        dispatch({
            type: RTO_DETAILS_UPDATE,
            payload: data,
        });
    } else {
        return res;
    }
};

export const commissionPayoutCasesRequest = (page = 1, action ,filter='') => async (dispatch) => {
    let keys = Object.keys(filter);
    let url = `${Config.CarLoan.commissionPayoutCasesList}?page=${page}&action=${action}`;
    if(keys){
        keys.map(val => {
            if(filter[val]){
                url+= `&${val}=${filter[val]}`
            }
        })
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    const {data} = res;
    dispatch({
        type: COMMISSION_PAYOUT_CASE_LIST,
        payload: data.response,
    });
    return data.response;
}

export const validateInvoiceStatus = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.invoiceValidateStatus}`
    );

    if (res?.data?.response) {
        const { status, message, data: payloadData } = res.data.response;

        dispatch({
            type: VALIDATE_INVOICE_STATUS,
            payload: {
                status,
                message,
                data: payloadData,
            },
        });

        return res.data.response;
    } else {
        return res?.data;
    }
};

export const previewInvoiceRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.previewInvoice}`
    );

    if (res?.data?.response) {
        const { status, message, data: payloadData } = res.data.response;

        dispatch({
            type: PREVIEW_INVOICE,
            payload: {
                status,
                message,
                data: payloadData,
            },
        });

        return res.data.response;
    } else {
        return res?.data;
    }
};

export const raiseInvoiceWithReconRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.CarLoan.raiseInvoiceWithRecon}`
    );

    if (res?.data?.response) {
        const { status, message, data: payloadData } = res.data.response;

        dispatch({
            type: RAISE_INVOICE,
            payload: {
                status,
                message,
                data: payloadData,
            },
        });

        return res.data.response;
    } else {
        return res?.data;
    }
};


export const carBrandForB2CRequest = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarLoan.carBrandForB2C}`
    );
    const {data} = res;
    dispatch({
        type: CAR_BRAND_FOR_B2C,
        payload: data?.response?.data,
    });
}

export const carModelForB2CRequest = (brandId = null, brandName = null) => async (dispatch) => {
    let url = `${Config.CarLoan.carModelForB2C}?`;
    let params = [];

    if (brandId !== undefined && brandId !== null && brandId !== '') {
        params.push(`brand_id=${brandId}`);
    }

    if (brandName !== undefined && brandName !== null && brandName !== '') {
        params.push(`brand_name=${brandName}`);
    }

    url += params.join('&');

    const res = await callWebService(callTypes.get, '', url);
    const { data } = res;

    dispatch({
        type: CAR_MODEL_FOR_B2C,
        payload: data?.response?.data,
    });
};


